/* TODO - This legacy component needs to be remove when we retire UPLOAD_MIGRATION_TO_GRAPHQL_4090 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SpreadsheetParserWorksheet } from '../../web-workers/spreadsheet-parser-worksheet';

@Component({
    selector: 'app-worksheet-tabs-content',
    templateUrl: './worksheet-tabs-content.component.html',
    styleUrls: ['./worksheet-tabs-content.component.scss'],
    standalone: false
})
export class WorksheetTabsContentComponent {
  @Input() worksheets!: Array<SpreadsheetParserWorksheet>;
  @Input() selectedWorksheet!: SpreadsheetParserWorksheet;
  @Output() updatedWorksheet: EventEmitter<SpreadsheetParserWorksheet> =
    new EventEmitter<SpreadsheetParserWorksheet>();

  constructor() {}

  updateSelection(value: SpreadsheetParserWorksheet) {
    this.updatedWorksheet.emit(value);
  }
}
